import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import GrowaveConfigurationEntity from "@lib/GrowaveConfigurationProvider/GrowaveConfigurationEntity";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { create } from "superstruct";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { I18nApiRecords } from "../GwI18n/loaders/I18nApiLoader/schemas";
import { TranslationsApiServiceInterface } from "../GwI18n/loaders/I18nApiLoader/TranslationsApiServiceInterface";
import { GetTranslationsResponseSchema } from "./TranslationsResponseSchema";

class TranslationsApiService implements TranslationsApiServiceInterface {
    constructor(
        private readonly apiClient: ApiClientInterface,
        private readonly growaveConfiguration: GrowaveConfigurationEntity,
        private readonly logger: LoggerInterface
    ) {}

    public getTranslations(
        namespace: string,
        locale: string
    ): Observable<I18nApiRecords> {
        return this.apiClient
            .get({
                url: "/storefront-api/translations",
                responseType: "json",
                queryParams: {
                    /**
                     * Bro, do not dare to change the order of parameters, otherwise cloudfront invalidation will break (@VLZH)
                     */
                    namespace,
                    locale,
                    shop: this.growaveConfiguration.myshopifyDomain,
                },
            })
            .pipe(
                map((response) => {
                    const result = create(
                        response.body,
                        GetTranslationsResponseSchema
                    );
                    return result.items.reduce((acc, current) => {
                        return {
                            ...acc,
                            [current.key]: current.value,
                        };
                    }, {});
                })
            );
    }
}

export default TranslationsApiService;
